/**
 * PublicErrorPage — handles 404, 429, 500 and network errors on public pages.
 */

import React from 'react';

export default function PublicErrorPage({ error, onRetry }) {
  const status = error?.status;

  let title = 'Something went wrong';
  let message = 'Please refresh the page and try again.';
  let icon = '⚠️';

  if (status === 404) {
    title = 'Page not available';
    message = 'This page does not exist or has been taken offline.';
    icon = '🔍';
  } else if (status === 429) {
    title = 'Too many requests';
    message = 'Please wait a moment and try again.';
    icon = '⏳';
  }

  return (
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ minHeight: '60vh', padding: '2rem 1rem' }}
    >
      <div style={{
        background: '#fff',
        borderRadius: 20,
        boxShadow: '0 8px 40px rgba(0,0,0,0.08), 0 2px 12px rgba(0,0,0,0.04)',
        padding: '3rem 2.5rem',
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 64, marginBottom: 20, lineHeight: 1 }}>
          {icon}
        </div>
        <h2 style={{
          fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25,
          color: '#0f172a', marginBottom: '0.75rem',
        }}>
          {title}
        </h2>
        <p style={{
          fontSize: '0.9rem', color: '#64748b',
          lineHeight: 1.65, maxWidth: 360,
          margin: '0 auto 2rem',
        }}>
          {message}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            style={{
              background: 'var(--primary-color)',
              color: '#fff',
              border: 'none',
              borderRadius: 999,
              padding: '10px 28px',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
              transition: 'opacity 150ms ease, transform 150ms ease, box-shadow 150ms ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.opacity = '0.9';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.18)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
            }}
          >
            <i className="bi bi-arrow-clockwise" />
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
